// extracted by mini-css-extract-plugin
module.exports = {"tagsList":"tags-module--tags-list--2PyR1","tagItem":"tags-module--tag-item--3ZE2D","tagsList2":"tags-module--tags-list2--1OUa9","tagItem2":"tags-module--tag-item2--2O1WS"};